/* eslint-disable import/prefer-default-export */

export const ARTIST_CHANGED = 'ARTIST_CHANGED';
export const TAG_MANAGER_OPEN_CHANGED = 'TAG_MANAGER_OPEN_CHANGED';
export const TAG_MANAGER_FILTER_CHANGED = 'TAG_MANAGER_FILTER_CHANGED';
export const AVAILABLE_TAGS_CHANGED = 'AVAILABLE_TAGS_CHANGED';
